import { Inertia } from '@niknevis/inertia'
import { defineComponent } from '@vue/composition-api'
import form from './form'
import InertiaLink from './link'
import remember from './remember'

let app = {}

// @ts-ignore
window.Inertia = Inertia

export default defineComponent({
  name: 'Inertia',

  props: {
    initialPage: {
      type: Object,
      required: true
    },
    resolveComponent: {
      type: Function,
      required: true
    },
    resolveErrors: {
      type: Function,
      required: false
    },
    transformProps: {
      type: Function,
      required: false
    }
  },

  data() {
    return {
      component: null as any,
      page: {},
      key: null as any
    }
  },

  created() {
    app = this
    Inertia.init({
      initialPage: this.initialPage as any,
      resolveComponent: this.resolveComponent,
      // @ts-ignore
      resolveErrors: this.resolveErrors as any,
      transformProps: this.transformProps,
      beforeRouteEnter: (...args) => {
        console.log(args)
      },
      swapComponent: async ({ component, page, preserveState }) => {
        this.component = component
        this.page = page
        this.key = preserveState ? this.key : Date.now()
      }
    })
  },

  render(h) {
    if (this.component) {
      if (this.$scopedSlots.default) {
        return this.$scopedSlots.default({
          key: this.key,
          component: this.component,
          page: this.page,
          // @ts-ignore
          props: this.page.props
        })
      }

      // @ts-ignore
      const child = h(this.component, {
        key: this.key,
        // @ts-ignore
        props: this.page.props
      })

      if (this.component.layout) {
        if (typeof this.component.layout === 'function') {
          // @ts-ignore
          return this.component.layout(h, child)
        } else if (Array.isArray(this.component.layout)) {
          // @ts-ignore
          return this.component.layout
            .concat(child)
            .reverse()
            .reduce((child, layout) => h(layout, [child]))
        }
        // @ts-ignore
        return h(this.component.layout, [child])
      }

      return child
    } else {
      if (this.$scopedSlots.loading) {
        return this.$scopedSlots.loading({})
      }
    }
  }
})

export const plugin = {
  install(Vue) {
    // @ts-ignore
    Inertia.form = form
    Object.defineProperty(Vue.prototype, '$inertia', { get: () => Inertia })
    // @ts-ignore
    Object.defineProperty(Vue.prototype, '$page', { get: () => app.page })
    Vue.mixin(remember)
    Vue.component('InertiaLink', InertiaLink)
  }
}

